// extracted by mini-css-extract-plugin
export default {"container":"styles-modulecontainer-fUk1d","title":"styles-moduletitle-+tS-b","tip":"styles-moduletip-XCeTb","warning":"styles-modulewarning-WyFAX"};